<template>
  <div class="themepage">
    <div class="leftbox">
      <el-menu
      
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      @select="handleSelect">
       
      <el-menu-item index="1">
        <div slot="title" class="el-menuf">研究单元</div>
      </el-menu-item>
    </el-menu>
    </div>
    <div class="rightbox">
      <div class="title">
        <div class="menuname">研究单元</div>
      </div>
      <div class="content">
        <el-tree
          :data="treedata"
          :props="defaultProps"
          accordion
          @node-click="handleNodeClick">
        </el-tree>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/home.js"
import Vue from 'vue'
import {Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,} from 'element-ui';
  Vue.use(Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,);
export default {
  name: 'zhuanti',
  props: {
    msg: String
  },
  data() {
      return {
        treedata: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
      };
    },
    created(){
      this.getloadTreeData();
  },
  methods: {
    handleOpen(key, keyPath) {
        console.log('open',key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log('close',key, keyPath);
      },
      handleSelect(key, keyPath) {
        console.log('elsect',key, keyPath);
        
      },
    handleNodeClick(data) {
      console.log(data);
        this.$router.push({name:'ResearchUnit',params:{code:data.code,label:data.label}});
    },
    getloadTreeData(){
      //专题分类
      let params = {
        async: false,
        pcode: ""
      };
      api.getloadTreeData(params)
        .then((res)=>{
          let treedatadiy=[]
          if(res.code==0&&res.result.length>0){
            this.treedata= this.diyTreeDataFn(res.result);
            
          }
        }).catch((err) => {
          });
    },
    diyTreeDataFn(data){
      let that=this;
      let treearr=[]
      for(let i in data){
        if(data[i].children&&data[i].children.length>0){
          
          treearr.push({
            label: data[i].title,
            code:data[i].code,
            children:that.diyTreeDataFn(data[i].children)
          })
        }else{
          treearr.push({
            label: data[i].title,
            code:data[i].code,
          })
        }
      }
        return treearr
    },
  },
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.themepage{
  width: 1200px;
  margin: 0 auto;
  padding-top: 16px;
  padding-bottom: 64px;
  overflow: hidden;
  .leftbox{
    width: 240px;
    float: left;
    margin-left: 16px;
    .el-submenu{
      width: 240px;
      
      background: #F6F6F6;
      border-radius: 4px;
      margin-bottom: 4px;
      .el-submenu__title{
        padding-left: 24px;
        padding-right: 16px;
        height: 48px;
        line-height: 48px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #25365E;
      }
    }
    .el-menu>.el-menu-item{
      width: 240px;
      
      background: #F6F6F6;
      border-radius: 4px;
      margin-bottom: 4px;
      height: 48px;
        line-height: 48px;
      .el-menuf{
        padding-left: 24px;
        padding-right: 16px;
        height: 48px;
        line-height: 48px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #25365E;
      }
    }
    .el-menu-item.is-active , .el-menu-item.is-active div{
      background-color: #FFFFFF;
      color: #376EF4 !important;
    }
    .el-menu{
      border: none;
    }
    .el-menu.el-menu--inline{
      box-shadow: 0px 0px 8px 0px rgba(137,154,176,0.2);
      padding-bottom: 20px;
    }
    .el-menu-item{
      font-size: 14px;
font-family: Source Han Sans CN;
font-weight: 400;
color: #333333;
width: 208px;
height: 32px;
line-height: 32px;
border-bottom: 1px dotted #E6E6E6;
margin: 0 auto;
padding: 0;
padding-left: 0px !important;
    }
    .el-menu-item-group__title{
      padding-top: 5px;
      padding-bottom: 5px;
    }
    .el-menu-item.is-active{
      background-color: #FFFFFF;
      color: #376EF4;
    }
    .el-menu-item:hover{
      color: #376EF4;
      background-color: #FFFFFF;
    }
  }
  .rightbox{
    float: right;
    width: 924px;
    // height: 590px;
    padding-bottom: 18px;
    background: #FFFFFF;
    border: 1px solid #E6E6E6;
    .title{
      width: 892px;
      margin: 0 auto;
      border-bottom: 2px solid #376EF4;
      margin-top: 12px;
      margin-bottom: 16px;
      .menuname{
        width: 172px;
      height: 36px;
      background: #376EF4;
      border-radius: 4px 4px 0px 0px;
      margin-left: 8px;
      line-height: 36px;
      color: #FFFFFF;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      text-align: center;
      }
    }
    .content{
      width: 892px;
      margin: 0 auto;
      background: #FFFFFF;
      box-shadow: 0px 0px 8px 0px rgba(137,154,176,0.2);
      position: relative;
        padding: 20px 0 58px 38px;
    }
  }
}
</style>
